module["exports"] = [
  "Diesel",
  "Electric",
  "Gasoline",
  "Hybrid"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/vehicle/fuel.js
// module id = 2661
// module chunks = 1609